import Homepage from "./pages/home";

function App() {
  return (
    <div>
      <Homepage/>
    </div>
  );
}

export default App;
